import React from 'react';
import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

interface InlineAIButtonProps {
  onClick: (e: React.MouseEvent) => void;
  isActive?: boolean;
  className?: string;
}

export function InlineAIButton({ onClick, isActive = false, className }: InlineAIButtonProps) {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      className={cn(
        "absolute bottom-3 right-3 w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 z-10",
        isActive
          ? "bg-partnr text-partnr-foreground shadow-lg"
          : "bg-muted/80 hover:bg-partnr/20 text-muted-foreground hover:text-partnr backdrop-blur-sm",
        className
      )}
      title="AI Assistant"
    >
      <Sparkles className="w-4 h-4" />
    </button>
  );
}
